import React from "react"
import { SpRowTable } from "components/molecules/table"
import { map, isEmpty } from "lodash"

interface props {
  headerList?: Array<Function>
  bodyList: Array<{
    title: string | Function
    value: Function
  }>
  data: Array<object>
  onClick?: Function
}

export const SpDetailTable = (props: props) => {
  const { data, headerList, bodyList, onClick } = props
  return !isEmpty(data) ? (
    <div className="sp-detail-body-wrapper">
      {map(data, (items, id: number) => {
        const _data = data[id]
        return headerList ? (
          <div
            className="sp-detail-table-wrapper"
            onClick={() => props.onClick && props.onClick(_data)}
          >
            <div className="sp-detail-table-header">
              {map(headerList, items => {
                return items(_data)
              })}
            </div>
            <div className="sp-detail-table-contents">
              <SpRowTable
                list={bodyList}
                data={_data}
                // onClick={onClick}
                className="table-striped table-index-detail"
              />
            </div>
          </div>
        ) : (
          <div className="sp-detail-table-contents">
            <SpRowTable
              list={bodyList}
              data={_data}
              // onClick={onClick}
              className="table-striped table-index-detail"
            />
          </div>
        )
      })}
    </div>
  ) : (
    <div className="pagination-info">表示内容がありません</div>
  )
}
